import { RequestUseCase } from "@tsTypes/__generated__/enums/request_use_case";
import { RequestsFeedbackDeadlineReminderName } from "@tsTypes/__generated__/enums/requests/feedback_deadline_reminder/name";
import { RequestsFeedbackDeadlineReminderStage } from "@tsTypes/__generated__/enums/requests/feedback_deadline_reminder/stage";
import { RequestPartnerTypes } from "./__generated__/enums/request_partner_types";
import { RequestForExpertsShowResponse } from "./request_for_experts/show";
import { RequestForStartupsShowResponse } from "./request_for_startups/show";
import { RfpPageRequest } from "./rfps/rfp_page";

export { RequestUseCase };

// NOTE: Also update config/initializers/request_custom_data_data_type.rb
export interface RequestCustomData {
  is_from_pepsico_procurement: boolean;
  feedback_deadlines_disabled: boolean;
}

export enum RequestableType {
  OPEN_CALL = "OpenCall",
  RFP = "Rfp",
  REQUEST_FOR_STARTUP = "RequestForStartup",
  REQUEST_FOR_EXPERT = "RequestForExpert",
}

// Used for public-facing features
export enum LaunchableRequestStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  COMING_SOON = "COMING_SOON",
  IN_EXTENSION = "IN_EXTENSION",
}

// Used for sponsor-only features
export enum RequestStatus {
  DRAFT = "Draft",
  SUBMITTED_FOR_REVIEW = "Submitted For Review",
  ACTIVE = "Active",
  PAUSED = "Paused",
  COMPLETE = "Complete",
  COMING_SOON = "Coming Soon",
  EVALUATING = "Evaluating",
  CANCELLED = "Cancelled",
  ARCHIVED = "Archived",
}

export { RequestPartnerTypes };

export const REQUEST_PARTNER_TYPE_LABELS = {
  [RequestPartnerTypes.ACADEMIC_RESEARCHERS]: "Academic researchers",
  [RequestPartnerTypes.STARTUPS]: "Startups",
  [RequestPartnerTypes.SUPPLIERS]: "Suppliers",
  [RequestPartnerTypes.SERVICE_PROVIDERS]: "Service providers (CROs/CMOs)",
  [RequestPartnerTypes.CONSULTANTS]: "Consultants",
};

export const REQUEST_USE_CASE_LABELS = {
  [RequestUseCase.NOVEL_TECHNOLOGY]: "Novel technology",
  [RequestUseCase.PROCESS_PRODUCT_IMPROVEMENTS]: "Process & product improvements",
  [RequestUseCase.TESTING_ANALYSIS]: "Testing & analysis",
  [RequestUseCase.EXPERTS]: "Expertise",
  [RequestUseCase.PROGRAM_PARTICIPANTS]: "Program participants",
};

export const REQUEST_USE_CASE_SHORT_LABELS = {
  [RequestUseCase.NOVEL_TECHNOLOGY]: "Novel tech",
  [RequestUseCase.PROCESS_PRODUCT_IMPROVEMENTS]: "Tech improvement",
  [RequestUseCase.TESTING_ANALYSIS]: "Testing & analysis",
  [RequestUseCase.EXPERTS]: "Expertise",
  [RequestUseCase.PROGRAM_PARTICIPANTS]: "Startup program",
};

// Keep in sync with app/structs/requests/feedback_deadline_reminder.rb
export type FeedbackDeadlineReminder = {
  stage: RequestsFeedbackDeadlineReminderStage;
  name: RequestsFeedbackDeadlineReminderName;
  title: string;
  text: string;
  deadline_date?: string;
};

export type RequestUnion =
  | RfpPageRequest
  | RequestForExpertsShowResponse
  | RequestForStartupsShowResponse;
